//INITIAL DATA
import { fetchLandingPageData } from "../../pages/Landing/initData";
import { fetchLandingCategoriesPageData } from "../../pages/LandingCategories/initData";
import { fetchAuthorProfilePageData } from "../../pages/AuthorProfilePage/initData";
import { fetchLandingNewsPageData } from "../../pages/LandingNews/initData";
import { fetchDetailPageData } from "../../pages/Detail/initData";
import { fetchDetailNoAdsPageData } from "../../pages/DetailNoAds/initData";
import { fetchLiveStoryPageData } from "../../pages/LiveStory/initData";
import { fetchVideoDetailPageData } from "../../pages/VideoDetailPage/initData";
import { fetchTopicPageData } from "../../pages/Topic/initData";
import { fetchNewsLocalData } from "../../pages/LandingNewsLocal/initData";
import { notFound, errorCode } from "../../pages/ErrorPage/initData";
import {
    fetchPreviewPageData,
    fetchFinancePageData,
    fetchBlankPageData,
} from "../../pages/BlankPage/initData";
import { fetchFlexibleLandingPageData } from "../../pages/FlexibleLandingPage/initData";
import { createTrackedLazyComponent as trackLazy } from "../chunk-tracker/component";

// EXTRA

const LandingShows = trackLazy(
    () =>
        import(
            /* webpackChunkName: "LandingShows" */
            "../../pages/LandingShows/component"
        ),
    "LandingShows"
);
const Detail = trackLazy(
    () =>
        import(/* webpackChunkName: "Detail" */ "../../pages/Detail/component"),
    "Detail"
);
const LiveStory = trackLazy(
    () =>
        import(
            /* webpackChunkName: "LiveStory" */ "../../pages/LiveStory/component"
        ),
    "LiveStory"
);
const Landing = trackLazy(
    () =>
        import(
            /* webpackChunkName: "Landing" */ "../../pages/Landing/component"
        ),
    "Landing"
);
const AuthorProfilePage = trackLazy(
    () =>
        import(
            /* webpackChunkName: "AuthorProfilePage" */ "../../pages/AuthorProfilePage/component"
        ),
    "AuthorProfilePage"
);
const ErrorPage = trackLazy(
    () =>
        import(
            /* webpackChunkName: "ErrorPage" */ "../../pages/ErrorPage/component"
        ),
    "ErrorPage"
);
const ErrorStatusPage = trackLazy(
    () =>
        import(
            /* webpackChunkName: "ErrorStatusPage" */ "../../pages/ErrorStatusPage/component"
        ),
    "ErrorStatusPage"
);
const Topic = trackLazy(
    () => import(/* webpackChunkName: "Topic" */ "../../pages/Topic/component"),
    "Topic"
);
const Show = trackLazy(
    () => import(/* webpackChunkName: "Show" */ "../../pages/Show/component"),
    "Show"
);

const FinancePage = trackLazy(
    () =>
        import(
            /* webpackChunkName: "FinancePage" */ "../../pages/BlankPage/component.finance"
        ),
    "FinancePage"
);
const FrequencyPage = trackLazy(
    () =>
        import(
            /* webpackChunkName: "FrequencyPage" */ "../../pages/BlankPage/component.frequency"
        ),
    "FrequencyPage"
);
const LandingNewsLocal = trackLazy(
    () =>
        import(
            /* webpackChunkName: "LandingNewsLocal" */ "../../pages/LandingNewsLocal/component"
        ),
    "LandingNewsLocal"
);
const LandingNews = trackLazy(
    () =>
        import(
            /* webpackChunkName: "LandingNews" */ "../../pages/LandingNews/component"
        ),
    "LandingNews"
);
const LandingNewsPOC = trackLazy(
    () =>
        import(
            /* webpackChunkName: "LandingNewsPOC" */ "../../pages/LandingNews/component.poc"
        ),
    "LandingNewsPOC"
);
const LandingPodcasts = trackLazy(
    () =>
        import(
            /* webpackChunkName: "LandingPodcasts" */ "../../pages/LandingPodcasts/component"
        ),
    "LandingPodcasts"
);
const LandingSearch = trackLazy(
    () =>
        import(
            /* webpackChunkName: "LandingSearch" */ "../../pages/LandingSearch/component"
        ),
    "LandingSearch"
);
const LandingSports = trackLazy(
    () =>
        import(
            /* webpackChunkName: "LandingSports" */ "../../pages/LandingSports/component"
        ),
    "LandingSports"
);
const Preview = trackLazy(
    () =>
        import(
            /* webpackChunkName: "Preview" */ "../../pages/Preview/component"
        ),
    "Preview"
);
const VideoDetailPage = trackLazy(
    () =>
        import(
            /* webpackChunkName: "VideoDetailPage" */ "../../pages/VideoDetailPage/component"
        ),
    "VideoDetailPage"
);

const LandingCategories = trackLazy(
    () =>
        import(
            /* webpackChunkName: "LandingCategories" */ "../../pages/LandingCategories/component"
        ),
    "LandingCategories"
);
const FlexibleLandingPage = trackLazy(
    () =>
        import(
            /* webpackChunkName: "FlexibleLandingPage" */ "../../pages/FlexibleLandingPage/component"
        ),
    "FlexibleLandingPage"
);

const DetailNoAds = trackLazy(
    () =>
        import(
            /* webpackChunkName: "DetailNoAds" */ "../../pages/DetailNoAds/component"
        ),
    "DetailNoAds"
);
const Sitemap = trackLazy(
    () =>
        import(
            /* webpackChunkName: "Sitemap" */ "../../components/Sitemap/component"
        ),
    "SiteMap"
);
const AppStatus = trackLazy(
    () =>
        import(
            /* webpackChunkName: "AppStatus" */ "../../components/AppStatus/component"
        ),
    "AppStatus"
);

const AccountWrapper = trackLazy(
    () =>
        import(
            /* webpackChunkName: "AccountWrapper" */ "../../pages/AccountWrapper/component"
        ),
    "AccountWrapper"
);

const routes = [
    {
        // homepage
        path: "/",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section*/(swimlane|featured|widgets)",
        component: ErrorPage,
        getInitialData: notFound,
    },
    {
        path: "/:section(documentaries)/:subSection(specials)/:title-:contentId(\\d\\.\\d+)",
        exact: true,
        component: Detail,
        getInitialData: fetchDetailPageData,
    },
    {
        path: "/:section(accessibility)/:title-:contentId(\\d\\.\\d+)",
        exact: true,
        component: DetailNoAds,
        getInitialData: fetchDetailNoAdsPageData,
    },
    {
        path: "/:section(account)/privacy/:title-:contentId(\\d\\.\\d+)",
        exact: true,
        component: DetailNoAds,
        getInitialData: fetchDetailNoAdsPageData,
    },
    {
        path: "/:section*/author/:title-:contentId(\\d\\.\\d+)",
        exact: true,
        component: AuthorProfilePage,
        getInitialData: fetchAuthorProfilePageData,
    },
    {
        path: "/:section*/livestory/:title-:contentId(\\d\\.\\d+)",
        exact: true,
        component: LiveStory,
        getInitialData: fetchLiveStoryPageData,
    },
    {
        path: "/:section*/:title-:contentId(\\d\\.\\d+)",
        exact: true,
        component: Detail,
        getInitialData: fetchDetailPageData,
    },
    {
        path: "/:section(arts|news|comedy|life|2017|radio)/:subSection(shows)",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section+/(topic|cbc-topic)/:kind/:keywords+",
        exact: true,
        component: Topic,
        getInitialData: fetchTopicPageData,
    },
    {
        path: "/:section(accessibility)",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(canadaday)/",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    /***
     * 2017 Routes
     */
    {
        path: "/:section(2017)/:subSection(nye)*",
        exact: true,
        component: Landing,
        getInitialData: fetchLandingPageData,
    },
    {
        path: "/:section(2017)/:subSection(whatsyourstory)*",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(2017)/:title/:subPage*",
        exact: true,
        component: Show,
        getInitialData: fetchLandingPageData,
    },
    /**
     * Archives Routes
     */
    {
        path: [
            "/:section(archives)/:subSection(sports|history|arts)",
            "/:section(archives)",
        ],
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    /***
     * Arts Routes
     */
    {
        path: "/:section(arts)",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(arts)/:subsection(watch|artuncontained)*",
        exact: true,
        component: Landing,
        getInitialData: fetchLandingPageData,
    },
    {
        path: "/:section(arts)/:subsection(canadacouncildigitaloriginals|commotion|q|read|canadianscreenawards|secretpath|insurgenceresurgence)",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(arts)/:title",
        exact: true,
        component: Show,
        getInitialData: fetchLandingPageData,
    },
    /***
     * Books Routes
     */
    {
        path: "/:section(books)",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(books)/:subSection(canadareads)",
        exact: true,
        component: Show,
        getInitialData: fetchLandingPageData,
    },
    {
        path: "/:section(books)/bookends",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(books)/:subSection(canadareads|bookends)/:subSections*",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(books)/:subsection(thisplace|canadawrites|ggbooks|gillerprize|kids|literaryprizes|readinglists|transmission)",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(books)/:subSections*",
        exact: true,
        component: Landing,
        getInitialData: fetchLandingPageData,
    },
    /***
     * Comedy routes
     */
    {
        path: "/:section(comedy)",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    /***
     * Documentaries routes
     */
    {
        path: [
            "/:section(documentaries)",
            "/:section(documentaries)/:subSection(documentary-channel)",
            "/:section(documentaries)/:subSection(brief-but-spectacular|the-nature-of-things)",
            "/:section(documentaries)/:subSection(the-passionate-eye)",
            "/:section(documentaries)/:subSection(the-passionate-eye)/(episodes|articles)",
            "/:section(documentaries)/:subSection(short-docs)",
            "/:section(documentaries)/:subSection(short-docs)/(episodes|articles)",
            "/:section(documentaries)/:subSection(the-nature-of-things)/(episodes|articles)",
            "/:section(documentaries)/:subSection(blacklife)",
            "/:section(documentaries)/:subSection(fortheculture)",
        ],
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(documentaries)/:subSection(specials)",
        exact: true,
        component: Landing,
        getInitialData: fetchLandingPageData,
    },
    {
        path: "/:section(documentaries)/:subSection(the-oland-murder|hotdocsoncbc|goodpeople|enslaved)",
        exact: true,
        component: Show,
        getInitialData: fetchLandingPageData,
    },
    {
        path: ["/:section(documentaries)", "/:section(documentaries)/**"],
        exact: true,
        component: Landing,
        getInitialData: fetchLandingPageData,
    },
    /***
     * Life Routes
     */

    {
        path: [
            "/:section(life)/:subSection(greatcanadianbakingshow)/(bakers|recipes|about)",
            "/:section(life)/:subSection(greatcanadianbakingshow)",
            "/:section(life)/:subSection(home|pets|style|thegoods|travel)",
        ],
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: [
            "/:section(life)/:subSection(wellness|backintimefordinner|fridgewars|backintimeforwinter|giveaways|culture|food|games|hellospring|holiday|work-money)",
        ],
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: ["/:section(life)/:subSection(holiday)/(cbcgives)"],
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(life)",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: [
            "/:section(life)/:subSection(jamieoliver|backintimefordinner)/:subPage*",
            "/:section(life)/:subSection(getawayguide)",
        ],
        exact: true,
        component: Show,
        getInitialData: fetchLandingPageData,
    },
    {
        path: [
            "/:section(life)/:subSection(hellospring)/:subPage(springscenes|hellospring-livestream|showusyourspring)",
        ],
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: ["/:section(life)/:subSection*/:subPage*"],
        exact: true,
        component: Landing,
        getInitialData: fetchLandingPageData,
    },

    /***
     * Music Routes
     */
    {
        path: "/:section(music)/:subSection(the-intro)",
        exact: true,
        component: Show,
        getInitialData: fetchLandingPageData,
    },
    {
        path: ["/:section(music)/:subSection(decadeofdrake)"],
        exact: true,
        component: Show,
        getInitialData: fetchLandingPageData,
    },
    {
        path: ["/:section(music)/:subSection(junos)/:subPage*"],
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: ["/:section(music)/:subSection(watch)/:category*"],
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: ["/:section(music)/:subSection(events|explore)"],
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(music)/:subSection(explore)/:subPage+",
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(music)/:subSection(events)/:subPage(festival|canadian-music-class-challenge|polaris|searchlight)",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: ["/:section(music)/:subSection(firstplaylive)*"],
        exact: true,
        component: Landing,
        getInitialData: fetchLandingPageData,
    },
    /***
     * News Routes
     */
    {
        path: [
            "/:section(news)/:subSection(business)/stocks/:stockId",
            "/:section(news)/:subSection(business)/forex/:forexId",
            "/:section(news)/:subSection(business)/index/:indexId",
            "/:section(news)/:subSection(business)/etf/:etfId",
            "/:section(news)/:subSection(business)/advancedsearch",
        ],
        exact: true,
        component: FinancePage,
        getInitialData: fetchFinancePageData,
    },
    {
        path: [
            "/:section(news)/:subSection(canada)/calgary/the-road-ahead",
            "/:section(news)/:subSection(canada)/montreal/quebecvotes2018",
            "/:section(news)/:subSection(canada)/new-brunswick/nbvotes2018",
            "/:section(news)/:subSection(elections)(/peivotes2019|/nlvotes2019|nwtvotes2019|/albertavotes2019)",
            "/:section(news)/:subSection(joandonaldsonscholars|theinvestigators|theweekly|editorsblog)",
            "/:section(news)/:subSection(politics)/powerandpolitics",
        ],
        exact: true,
        component: Show,
        getInitialData: fetchLandingPageData,
    },

    {
        path: [
            "/:section(news)/:subSection(canada)/:region(calgary)/community",
            "/:section(news)/:subSection(canada)/:region(edmonton)/community",
        ],
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(news)/:subSection(canada)/:region+/community",
        exact: true,
        component: LandingNews,
        getInitialData: fetchLandingPageData,
    },

    {
        path: "/:section(news)/covid-19/:subSection(international-news|coping-with-covid-19|fact-check|economy-and-finance|lives-remembered|stories-of-hope)",
        exact: true,
        component: Show,
        getInitialData: fetchLandingPageData,
    },
    {
        path: "/:section(news)/:subSection(climate|thenational|fifthestate|opinion|science|gopublic|indigenous|entertainment|health|investigates|politics|canada)",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(news)/:subSection(canada)/beingblackincanada",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(news)/:subSection(canada)/beingblackincanada/all",
        exact: true,
        component: Show,
        getInitialData: fetchLandingPageData,
    },
    {
        path: "/:section(arts|books|sports)/:subSection(beingblackincanada)",
        exact: true,
        component: Show,
        getInitialData: fetchLandingPageData,
    },
    {
        path: "/:section(news)/:subsection(canada)/british-columbia/local",
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(news)/canada/:subSection(british-columbia|calgary|saskatchewan|edmonton|sudbury)",
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(news)/:subSection(canada)/:region+",
        exact: true,
        component: LandingNewsPOC,
        getInitialData: fetchLandingNewsPageData,
    },
    {
        path: "/:section(news)/:subSection(business)",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(news)/:subSection(local)",
        exact: true,
        component: LandingNewsLocal,
        getInitialData: fetchNewsLocalData,
    },
    {
        path: ["/:section(news)/:subSection(marketplace)"],
        exact: true,
        component: Landing,
        getInitialData: fetchLandingPageData,
    },
    {
        path: "/:section(news)/:subSection(world)",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(news)/:subSections+",
        exact: true,
        component: LandingNews,
        getInitialData: fetchLandingPageData,
    },
    {
        path: "/:section(news)",
        exact: true,
        component: LandingNews,
        getInitialData: fetchLandingNewsPageData,
    },
    /***
     * Player Routes
     */
    {
        path: [
            "/player",
            "/player/live",
            "/player/:section(archives|arts|docs|life|music|news|sports)",
            "/player/:section(sports|news)/live",
            "/player/:section(sports)/:subSection(breakthrough|replays)",
            "/player/:section(sports)/:subSection(olympics|paralympics)/:season(summer)/:subPage(live|replays|highlights)",
            "/player/:section(news)/:subSection(canada)/:region+",
            "/player/:section(news)/:subSection(canada)/:region(edmonton)/our-edmonton",
        ],
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: [
            "/player/play/:mediaId",
            "/player/play/:mediaType(audio|video)/:mediaId",
        ],
        exact: true,
        component: VideoDetailPage,
        getInitialData: fetchVideoDetailPageData,
    },
    /***
     * Radio Routes
     */
    {
        path: "/:section(radio)/:subSection(frequency)",
        exact: true,
        component: FrequencyPage,
        getInitialData: fetchBlankPageData,
    },
    {
        path: "/:section(radio)/:subSection(podcasts)",
        exact: true,
        component: LandingPodcasts,
        getInitialData: fetchLandingPageData,
    },
    {
        path: "/:section(radio)/:subPage+",
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(radio)",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    /***
     * Sports Routes
     */
    {
        path: [
            "/:section(sports)/:subSection(crashed-ice)/:subPage*",
            "/:section(sports)/:subSection(podcasts)/:title(hnic|players-own-voice)*",
        ],
        exact: true,
        component: Show,
        getInitialData: fetchLandingPageData,
    },
    {
        path: [
            "/:section(sports)/all",
            "/:section(sports)/:subSection(olympics)/all",
        ],
        exact: true,
        component: LandingShows,
        getInitialData: fetchBlankPageData,
    },
    {
        path: "/:section(sports)/:subPage(iwd)",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(sports)/:subSection(olympics)/myolympics",
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: [
            "/:section(sports)/:subSection(shows)/:subPage+",
            "/:section(sports)/:subSection(shows)",
        ],
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: [
            "/:section(sports)/:subSection(naig)/:subPage+",
            "/:section(sports)/:subSection(naig)",
        ],
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: [
            "/:section(sports)/:subSection(hall-of-fame)/:subPage+",
            "/:section(sports)/:subSection(hall-of-fame)",
        ],
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: [
            "/:section(sports)/:subSection(pan-american-games)/:subPage+",
            "/:section(sports)/:subSection(pan-american-games)",
        ],
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: [
            "/:section(sports)/:subSection(parapanam)/:subPage+",
            "/:section(sports)/:subSection(parapanam)",
        ],
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(sports)/:subSection(olympics)/:season(summer|winter)/sports",
        exact: true,
        component: LandingCategories,
        getInitialData: fetchLandingCategoriesPageData,
    },
    {
        path: "/:section(sports)/paralympics/:platform(streaming|tv)-schedule",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(sports)/olympics/winter/:platform(streaming|tv)-schedule",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(sports)/:subSection(olympics)/winter/:sport(figure-skating|curling|skiing|speed-skating|snowboard)/:platform(streaming)-schedule",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(sports)/:sport(hockey)/nhl/:platform(streaming)-schedule",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(sports)/:subSection(basketball)/cebl/:platform(streaming)-schedule",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(sports)/:subSection(soccer)/cpl/:platform(streaming)-schedule",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(sports)/:subSection(equestrian|rugby|calgarystampede)/:platform(streaming)-schedule",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(sports)/baseball/little-league/:platform(streaming)-schedule",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(sports)/:platform(tv|streaming)-schedule",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: [
            "/:section(sports)/:subSection(olympics)",
            "/:section(sports)/:subSection(olympics)/:season(summer|winter)/:subPage*",
            "/:section(sports)/:subSection(paralympics)",
            "/:section(sports)/:subSection(paralympics)/:subPage(video|features)",
            "/:section(sports)/commonwealthgames",
            "/:section(sports)/:subSection(commonwealthgames)/video",
            "/:section(sports)/commonwealthgames/:platform(tv|streaming)-schedule",
            "/:section(sports)/:subSection(hockey)/:subPage/(tv|streaming)-schedule",
            "/:section(sports)/:subSection(hockey)/:subPage",
            "/:section(sports)/:subSection(hockey)",
            "/:section(sports)/:subSection(basketball)",
            "/:section(sports)/:subSection(football)",
            "/:section(sports)/:subSection(baseball)",
            "/:section(sports)",
        ],
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(sports)/:subSections*",
        exact: true,
        component: LandingSports,
        getInitialData: fetchLandingPageData,
    },
    /***
     * Television Routes
     */
    {
        path: "/:section(television)/:subSection(whatreyouat|anyonesgame|arcticvets|raceagainstthetide)",
        exact: true,
        component: Show,
        getInitialData: fetchLandingPageData,
    },
    {
        path: [
            "/:section(television)/:subSection(battleoftheblades)/(blades-performances|mini-blades|skaters)",
            "/:section(television)/:subSection(higharctichaulers)/(ship|shore)",
            "/:section(television)/:subSection(canadasultimatechallenge|battleoftheblades|fromthevaults|higharctichaulers|watch|familyfeud|thedetectives|stillstanding|murdochmysteries|heartland|22minutes)",
            "/:section(television)/:subSection(stillstanding)/about",
        ],
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: ["/:section(television)/:subSection*"],
        exact: true,
        component: Landing,
        getInitialData: fetchLandingPageData,
    },
    // MISC ROUTES
    {
        path: "/:section(cape)",
        exact: true,
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: ["/:section(indspire|reflections)"],
        exact: true,
        component: Show,
        getInitialData: fetchLandingPageData,
    },
    {
        path: ["/:section(learning-english)/:subSection*"],
        exact: true,
        component: Show,
        getInitialData: fetchLandingPageData,
    },
    {
        path: ["/:section(shows)/:title"],
        exact: true,
        component: Show,
        getInitialData: fetchLandingPageData,
    },
    {
        path: "/meta/global/(header|footer)/:section*",
        component: Landing,
    },
    {
        path: "/meta/hiddentestpage",
        exact: true,
        component: Landing,
        getInitialData: fetchLandingPageData,
    },
    {
        path: "/meta/preview/:section*/:contentId",
        component: Preview,
        getInitialData: fetchPreviewPageData,
    },
    {
        path: [
            "/meta/nine-preview/:section*/:contentId(\\d\\.\\d+)",
            "/meta/nine-preview/:section*",
        ],
        component: Preview,
    },
    {
        path: "/meta/flexible/:section*",
        component: FlexibleLandingPage,
        getInitialData: fetchFlexibleLandingPageData,
    },
    {
        path: "/:section(search)",
        component: LandingSearch,
        getInitialData: fetchBlankPageData,
    },
    {
        path: "/sitemap",
        component: Sitemap,
        getInitialData: fetchBlankPageData,
    },
    {
        path: "/healthz",
        component: AppStatus,
    },
    {
        path: ["/account(/?)", "/account/*"],
        component: AccountWrapper,
    },
    {
        path: [
            "/error/:status",
            "/:status.html", // Route Config for /xxx.html error pages e.g. /404.html or /502.html
        ],
        component: ErrorStatusPage,
        getInitialData: errorCode,
    },
    {
        path: "*",
        component: ErrorPage,
        getInitialData: notFound,
    },
];

export default routes;
